// Module
var code = "<a\r\n    class=\"dms-sidemenu-button dms-notification-button dms-tooltip\"\r\n    data-bind=\"attr: { data-dms-tooltip: getUserDataTextBlockToolTipNotifications }\"\r\n>\r\n    <i class=\"far fa-bell\"></i>\r\n    <span class=\"dms-notification-badge\" data-bind=\"text:count, visible: count\"></span>\r\n</a>\r\n";
// Exports
export default code;